import React, { useState, useEffect } from "react";
import { getProductHeirarchy } from "../../Utils/dataProductHeirarchy";
import { getGeographyHeirarchy } from "../../Utils/dataGeography";
import { openDatabase, upsertRecord, upgradeDatabaseInstance } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../../services/constants';
import { useFormContext } from "./FormContext";

const DataContext = React.createContext({
  data: null
});

const DataProvider = ({ children }) => {
  const [products, setProducts] = useState({ data: null, is_loading: false });
  const [geography, setGeography] = useState({ data: null, is_loading: false });
  const [isDataloading, setIsDataLoading] = useState(false);
  const { formData } = useFormContext();
  const data_upload_id = formData?.stage1?.data_upload_id;

  useEffect(() => {
    if (!data_upload_id) {
      setProducts({ data: null, is_loading: false });
      setGeography({ data: null, is_loading: false });
      setIsDataLoading(false);
      return;
    }

    const LoadProductsData = async () => {
      setProducts({ data: null, is_loading: true });

      const _productsDataAll = await getProductHeirarchy(data_upload_id);
      const { level6, ...__productsData } = _productsDataAll || {};

      await openDatabase(DATABASE_NAME, 1, upgradeDatabaseInstance);
      await upsertRecord(DATABASE_NAME, STORE_NAME, {
        id: "SKUS",
        data: level6 || [],
      });

      setProducts({
        data: _productsDataAll || { level1: [] },
        is_loading: false,
      });
    };

    const LoadGeographyData = async () => {
      setGeography({ data: null, is_loading: true });

      const _geoDataAll = await getGeographyHeirarchy(data_upload_id);

      setGeography({
        data: _geoDataAll || {},
        is_loading: false,
      });
    };

    const loadData = async () => {
      try {
        setIsDataLoading(true);
        await Promise.all([LoadProductsData(), LoadGeographyData()]);
      } catch (error) {
        console.error("Error loading hierarchy data:", error);
        setProducts({ data: { level1: [] }, is_loading: false });
        setGeography({ data: {}, is_loading: false });
      } finally {
        setIsDataLoading(false);
      }
    };

    loadData();
  }, [data_upload_id]);

  return (
    <DataContext.Provider value={{ products, geography, isDataloading }}>
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };